import JSZip from 'jszip';
import { readFileAsText } from '../services/ReadFile';

export class Archiver {
  private zipFile: JSZip = new JSZip();

  public reset(): void {
    this.zipFile = new JSZip();
  }

  public async addHashedFile(file: File) {
    const content = await readFileAsText(file);
    this.addContent(file.name, content);
  }

  public addContent(filename: string, content: string) {
    this.zipFile.file(filename, content);
  }

  public get blob() {
    return this.zipFile.generateAsync({ type: 'blob' });
  }
}